import React from 'react';
import fb from '../images/Facebook_black 1.png';
import tw from '../images/Twitter_black 1.png';
import yu from '../images/Youtube_black 1.png';
import md from '../images/Medium_black 1.png';
import logo from '../images/kalingarayanrunners_logo.png';
import { MapPinIcon, PhoneIcon, EnvelopeIcon } from '@heroicons/react/24/outline';

function Footer() {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    { icon: fb, href: "#", label: "Facebook", hoverColor: "hover:bg-blue-600" },
    { icon: tw, href: "#", label: "Twitter", hoverColor: "hover:bg-blue-400" },
    { icon: yu, href: "#", label: "YouTube", hoverColor: "hover:bg-red-600" },
    { icon: md, href: "#", label: "Medium", hoverColor: "hover:bg-gray-800" },
  ];

  const quickLinks = [
    { name: "Home", href: "/" },
    { name: "Registration", href: "/registration" },
 
  ];

  const legalLinks = [
    { name: "Privacy Policy", href: "#" },
    { name: "Terms of Service", href: "#" },
    { name: "Cookie Policy", href: "#" },
  ];

  return (
    <footer className="bg-gradient-to-br from-neutral-900 via-neutral-800 to-neutral-900 text-white relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-primary-500/5 rounded-full -translate-x-32 -translate-y-32"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-secondary-500/5 rounded-full translate-x-48 translate-y-48"></div>
      
      {/* Main Footer Content */}
      <div className="relative">
        <div className="container-custom section-padding-sm">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
            
            {/* Brand Section */}
            <div className="lg:col-span-2 space-y-6">
              <div className="flex items-center space-x-3">
                <img 
                  src={logo} 
                  alt="Kalingarayan Runners" 
                  className="h-12 w-auto"
                />
                <div>
                  <h3 className="text-2xl font-bold text-white">Kalingarayan Runners</h3>
                  <p className="text-neutral-400 text-sm">Running Towards Excellence</p>
                </div>
              </div>
              
              <p className="text-neutral-300 text-lg leading-relaxed max-w-md">
                Join our passionate community of runners dedicated to promoting health, 
                fitness, and community engagement through exciting running events and challenges.
              </p>
              
              {/* Contact Info */}
              <div className="space-y-3">
                <div className="flex items-center space-x-3 text-neutral-300">
                  <MapPinIcon className="w-5 h-5 text-primary-500" />
                  <span>Tamil Nadu, India</span>
                </div>
                <div className="flex items-center space-x-3 text-neutral-300">
                  <PhoneIcon className="w-5 h-5 text-primary-500" />
                  <span>+91 9842730160,+91 9944280160</span>
                </div>
                <div className="flex items-center space-x-3 text-neutral-300">
                  <EnvelopeIcon className="w-5 h-5 text-primary-500" />
                  <span>pioneerviji.tmc@gmail.com</span>
                </div>
              </div>
            </div>
            
            {/* Quick Links */}
            <div className="space-y-6">
              <h4 className="text-xl font-semibold text-white">Quick Links</h4>
              <ul className="space-y-3">
                {quickLinks.map((link, index) => (
                  <li key={index}>
                    <a 
                      href={link.href} 
                      className="text-neutral-300 hover:text-primary-400 transition-colors duration-300 flex items-center group"
                    >
                      <span className="w-2 h-2 bg-primary-500 rounded-full mr-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            
            {/* Social Media */}
            <div className="space-y-6">
              <h4 className="text-xl font-semibold text-white">Follow Us</h4>
              <div className="flex space-x-4">
                {socialLinks.map((social, index) => (
                  <a 
                    key={index}
                    href={social.href} 
                    className={`w-12 h-12 bg-neutral-800 rounded-xl flex items-center justify-center transition-all duration-300 hover:scale-110 ${social.hoverColor} group`}
                    aria-label={social.label}
                  >
                    <img 
                      src={social.icon} 
                      alt={social.label}
                      className="w-6 h-6 filter invert group-hover:invert-0 transition-all duration-300"
                    />
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
        
        {/* Bottom Bar */}
        <div className="border-t border-neutral-700">
          <div className="container-custom py-6">
            <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
              <div className="text-neutral-400 text-sm">
                © {currentYear} Kalingarayan Runners. All rights reserved. 
                <span className="text-primary-400">Powered by passion for running.</span>
              </div>
              
              <div className="flex space-x-6">
                {legalLinks.map((link, index) => (
                  <a 
                    key={index}
                    href={link.href} 
                    className="text-neutral-400 hover:text-primary-400 text-sm transition-colors duration-300"
                  >
                    {link.name}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
